module.exports = __webpack_public_path__ + "static/media/manageMySpace.50c0d8fd.svg";